import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import type { CalendarOptions } from "@fullcalendar/core";
import { FuiCalendarViewComponent } from "./fui-calendar-view.component";

/**
 * Lazy shell around FullCalendar. Its hosts are declared in UIModule, and @defer can't split the
 * dependencies of an NgModule component, so this standalone shell does the deferring instead:
 * FullCalendar and its plugins download the first time a calendar is shown.
 *
 * Pass `options` without `plugins`; the view adds them. Replace the object to update it.
 */
@Component({
  selector: "fui-calendar",
  standalone: true,
  imports: [FuiCalendarViewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @defer (on immediate) {
      <fui-calendar-view [options]="options"></fui-calendar-view>
    }
  `,
})
export class FuiCalendarComponent {
  @Input() options: CalendarOptions;
}
